import { Link, useNavigate } from "@tanstack/react-router";
import { type ReactNode } from "react";
import { post } from "../api";
import { useShares } from "../calendar/data";
import { CalendarPage } from "../calendar/page";
import { useI18n } from "../i18n";
import { useMe, useSetMe } from "../session";
import { Brand } from "../ui";
import { useConnections } from "./calendars";

/** Coquille de l'application connectée : barre supérieure et contenu. */
export function AppShell({ children, fixed }: { children: ReactNode; fixed?: boolean }) {
  const { t } = useI18n();
  const me = useMe();
  const setMe = useSetMe();
  const navigate = useNavigate();
  const logout = async () => {
    await post("/api/auth/logout").catch(() => {});
    setMe(null);
    navigate({ to: "/login" });
  };
  return (
    <div className={fixed ? "app app-fixed" : "app"}>
      <header className="topbar">
        <Link to="/" className="brand-link">
          <Brand />
        </Link>
        <nav className="topnav">
          <Link to="/" activeOptions={{ exact: true }}>
            {t("nav.calendar")}
          </Link>
          <Link to="/settings">{t("nav.settings")}</Link>
        </nav>
        <span className="topbar-user">{me.data?.name}</span>
        <button className="btn btn-ghost" onClick={logout}>
          {t("nav.logout")}
        </button>
      </header>
      {children}
    </div>
  );
}

export function HomePage() {
  const { t } = useI18n();
  const me = useMe();
  const connections = useConnections();
  const shares = useShares();
  const ready = connections.data && shares.data;

  // Sans agenda à soi ni agenda partagé : on invite à connecter un premier agenda.
  if (ready && connections.data!.length === 0 && shares.data!.withMe.length === 0) {
    return (
      <AppShell>
        <main className="page">
          <p className="eyebrow">{t("home.hello", { name: me.data?.name ?? "" })}</p>
          <h1 className="display">{t("home.emptyTitle")}</h1>
          <p className="muted measure">{t("home.connectBody")}</p>
          <div>
            <a className="btn btn-primary" href="/settings?section=calendars">
              {t("home.addFirst")}
            </a>
          </div>
        </main>
      </AppShell>
    );
  }
  return (
    <AppShell fixed>
      {ready ? <CalendarPage /> : <div className="boot" aria-busy="true" />}
    </AppShell>
  );
}
